const tableInstances = {};

const addHotTableComponent = (elementId, hotInstance) => {
    tableInstances[elementId] = hotInstance;
};

const removeHotTableComponent = (elementId, hotInstance) => {
    if (tableInstances[elementId] === hotInstance) {
        delete tableInstances[elementId];
    }
};

const getHotTableComponent = (elementId) => {
    return tableInstances[elementId];
};

const HotTableManager = {
    addHotTableComponent,
    removeHotTableComponent,
    getHotTableComponent,
};

export default HotTableManager;
